function nonResValue(data) {
    const nonResKeys = Object.keys(data).filter(key => key !== "res");
    if (nonResKeys.length === 1) {
        return data[nonResKeys[0]];
    }
    return null;
}
function toErrorObject(thing) {
    if (typeof thing === "undefined" || thing === null) {
        return new Error("Unknown error");
    }
    if (thing instanceof Error) {
        return thing;
    }
    if (typeof thing === "string") {
        return new Error(thing);
    }
    const obj = thing;
    const message = obj.err ||
        obj.error ||
        obj.message ||
        obj.msg ||
        obj.err_msg ||
        nonResValue(obj) ||
        String(obj) ||
        "Unknown response";
    return new Error(String(message));
}
/**
 * Reject with an Error object if response.res==='err', to try and normalise the various ways an error message can be returned
 * @param data
 */
export function rejectWithResErr(data) {
    if ((data === null || data === void 0 ? void 0 : data.res) === "err") {
        return ensureIsError(data);
    }
    return data;
}
export function ensureIsError(caught) {
    return Promise.reject(toErrorObject(caught));
}
